import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const AgendaList = props => <DefaultDataTable data={props} />;